export default {"src":"/_next/static/media/checkbox-checked-disabled.41da4ba4.svg","height":20,"width":20};